import React from "react";
import * as Styled from "./EmbedMediaLibrary.styled";
import { userService } from "../../services";
import { LibraryType } from "../../libs";

const getEmbedHtml = (darkMode: boolean) => `
<!doctype html>
<html>
<head>
  <link rel="stylesheet" href="https://dfw2f0tbeiwbc.cloudfront.net/membership/index.css" />
  <link rel="stylesheet" href="https://dfw2f0tbeiwbc.cloudfront.net/media/index.css" />
  <style>
    body {
      background-color: ${darkMode ? '#121212' : '#ffffff'};
    }
  </style>
</head>
<body>
  <div style="padding: 20px;">
  <div id="cembooClientJoinNowButton"></div>
  <div id="cemboo-media-library"></div>
  </div>
  <script src="https://dfw2f0tbeiwbc.cloudfront.net/membership/index.js"></script>
  <script src="https://dfw2f0tbeiwbc.cloudfront.net/media/index.js"></script>

  <script>
    const clientId = "c5ba6ab8-28c8-43d2-9891-942298023b67";
    window.onload = () => {
      initiateCembooMemberSpace();
      const CembooMediaLibrary = new window.CembooMediaLibrary(clientId, "false", false, false);
      const cembooMediaLibrary = CembooMediaLibrary.init();
    };
    const initiateCembooMemberSpace = () => {
      new window.CembooMemberSpace(clientId).init();
    };
  </script>
</body>
</html>
`;

export const EmbedMediaLibrary = () => {
    const [darkMode, setDarkMode] = React.useState(false);

    React.useEffect(() => {
        userService.getLibraryConfig(LibraryType.MediaLibrary).then((result) => {
            setDarkMode(result?.darkMode || false);
        });
    }, []);

    return <Styled.EmbedMediaLibraryWrapper>
        <Styled.LandscapeIframe
            srcDoc={getEmbedHtml(darkMode)}
            title="Media Library"
        />
    </Styled.EmbedMediaLibraryWrapper>;
};
